<div id="academy-courses" class="page-layout simple">

    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text" fxLayout="row" fxLayoutAlign="start center">

            <!-- <mat-icon [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="hero-icon">school</mat-icon> -->
            <button mat-icon-button class="mr-16" (click)="regresasFocusAnos()" *ngIf="anioelejido">
        <mat-icon>arrow_back</mat-icon>
      </button>
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                {{textoBanner | translate}}
            </h1>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
                <ng-container *ngIf="cargando">
                    <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <div fxLayout="column" fxLayoutAlign="space-between center">
                            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                            <h2>{{'LANDINFOCUS.WIZARD.CARGANDOF' | translate}}</h2>
                        </div>
                    </div>
                </ng-container>

                <!--cambios-->
                <ng-container *ngIf="!cargando">

                    <!-- Muestra los productos por año-->
                    <ng-container *ngIf="!anioelejido">
                        <div class="" fxLayout="column">
                            <div class="course" fxFlex="80" fxFlex.gt-sm="66" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" fxLayoutAlign="center center">
                                <video id="videoLanding" [@animate]="{value:'*',params:{y:'100%'}}" src="" controlslist="nodownload" controls fxFlex="70" fxLayoutAlign="center center" poster="">
              </video>
                            </div>
                            <ng-container *ngIf="productosAsignados.length == 0">
                                <div class="statusDiv" fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                    <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                                        <h2>{{'LANDINFOCUS.WIZARD.SINPRODS' | translate}}</h2>
                                        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="productosAsignados.length > 0">
                                <div class="" fxLayout="row wrap" fxLayoutAlign="space-between start" fxFlex="100">
                                    <div *ngFor="let producto of productosAsignados; let i = index; let last = last; let first = first;" fxFlex="50" class="course" fxFlex.gt-sm="50" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                        <div class="cursoCard" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                                            <div class="course-content" fxLayout="column">
                                                <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                                                    <div class="category" fxFlex>{{producto.tagStatus | translate}}</div>
                                                    <div *ngIf="producto.completo != 1" class="length" fxLayout="row" fxLayoutAlign="end center">
                                                        <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                                                    </div>
                                                </div>

                                                <div class="content p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                                    <div class="h1">{{producto.title | translate}}</div>
                                                    <div class="updated">{{'LANDINFOCUS.WIZARD.DONE' | translate}}{{producto.date}}</div>
                                                </div>

                                                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                                                    <button mat-button class="accent rndBt" fxFlex="100" (click)="anioelejidof(producto);">{{producto.start | translate}}</button>
                                                </div>



                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- Muestra las encuestas del año elegido -->
                    <ng-container *ngIf="anioelejido && mostrarEncuestas && !focusViejo">
                        <div class="" fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="100">
                            <ng-container *ngIf="mostrarEncuestas.data.length==0">
                                <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                    <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                                        <h2>{{'LANDINFOCUS.ENCUESTAS.NO-ENCU' | translate}}</h2>
                                        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="mostrarEncuestas.data.length>0">
                                <div class="" fxLayout="row" fxLayoutAlign="end center" >
                                <!-- <div class="" fxLayout="row" fxLayoutAlign="end center" *ngIf="productPa"> -->
                                    <h2 class="pr-20">{{'LANDINFOCUS.WIZARD.CREARENC' | translate}}</h2>
                                    <button mat-fab color="primary" aria-label="agregaPreg" (click)="nombreEncuesta();">
                <mat-icon>add</mat-icon>
              </button>
                                </div>
                                <div class="" fxLayout="row wrap">
                                    <ng-container *ngFor="let encuestas of mostrarEncuestas.data">
                                        <div class="course" fxFlex="100" fxFlex.gt-sm="33">
                                            <div class="cursoCard" fxFlex="100">
                                                <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                                                    <div class="header primary " fxLayout="row" fxLayoutAlign="center center">
                                                        <div class="category" fxFlex>{{'LANDINFOCUS.ENCUESTAS.TITULO' | translate}}</div>
                                                        <mat-icon *ngIf="productPa" color="white" (click)="eliminarEncuesta(encuestas._id);">delete_forever</mat-icon>
                                                    </div>

                                                    <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                                        <div class="h1 p-20 m-20">{{encuestas.nombre}} </div>
                                                        <div class="h1 p-20 m-20"> {{encuestas.fechaInicio |date:"fullDate":'':idiomaActual}}</div>
                                                    </div>

                                                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                                                        <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/'+producto.url+'/wizard/',producto.date,producto.instituto,producto.productoID,encuestas._id);">{{producto.start | translate}}</button>

                                                    </div>



                                                </div>
                                            </div>
                                        </div>

                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>

                    </ng-container>

                    <ng-container *ngIf="anioelejido && mostrarEncuestas && focusViejo">
                        <div class="" fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="100">
                            <ng-container *ngIf="mostrarEncuestas.surveys.length==0">
                                <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                    <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                                        <h2>{{'LANDINFOCUS.ENCUESTAS.NO-ENCU' | translate}}</h2>
                                        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="mostrarEncuestas.surveys.length>0">
                                <div class="" fxLayout="row" fxLayoutAlign="end center" >
                                <!-- <div class="" fxLayout="row" fxLayoutAlign="end center" *ngIf="productPa"> -->
                                    <h2 class="pr-20">{{'LANDINFOCUS.WIZARD.CREARENC' | translate}}</h2>
                                     <button mat-fab color="primary" aria-label="agregaPreg" (click)="nombreEncuesta();">
                <mat-icon>add</mat-icon>
              </button>
                                </div>
                                <div class="" fxLayout="row wrap">
                                    <ng-container *ngFor="let encuestas of mostrarEncuestas.surveys">
                                        <div class="course" fxFlex="100" fxFlex.gt-sm="33">
                                            <div class="cursoCard" fxFlex="100">
                                                <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                                                    <div class="header primary " fxLayout="row" fxLayoutAlign="center center">
                                                        <div class="category" fxFlex>{{'LANDINFOCUS.ENCUESTAS.TITULO' | translate}}</div>
                                                        <mat-icon  color="white" (click)="eliminarEncuesta(encuestas._id);">delete_forever</mat-icon>
                                                        <!-- <mat-icon *ngIf="productPa" color="white" (click)="eliminarEncuesta(encuestas._id);">delete_forever</mat-icon> -->
                                                    </div>

                                                    <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                                        <div class="h1 p-20 m-20">{{encuestas.name}} </div>
                                                        <!-- <div class="h1 p-20 m-20"> {{encuestas.fechaInicio |date:"fullDate":'':idiomaActual}}</div> -->
                                                    </div>

                                                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                                                        <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateToFocus('/'+producto.url+'/wizard/',producto.date,producto.instituto,producto.productoID,encuestas._id);">{{producto.start | translate}}</button>
                                                    </div>



                                                </div>
                                            </div>
                                        </div>

                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>

                    </ng-container>


                </ng-container>

            </div>
            <!-- / CONTENT -->

        </div>
